module.exports = __webpack_public_path__ + "img/cube-fragile.627ab65.svg";